import { pick } from 'ramda';

/** todo - below to be moved to common */
const withNullPropertiesAsUndefined = <T extends Record<string, any>>(it: T) =>
  Object.entries(it).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: value === null ? undefined : value,
    }),
    {},
  ) as T;

const areUpdatablePropertiesEqualAcrossObjects = <
  TUpdatable,
  TUpdatableProperties extends keyof TUpdatable,
  TUpdatablePropertiesArray extends readonly TUpdatableProperties[],
>(
  updatableProperties: TUpdatablePropertiesArray,
  a: { [K in TUpdatableProperties]: TUpdatable[K] },
  b: { [K in TUpdatableProperties]: TUpdatable[K] },
): boolean => {
  const aUpdatableProperties = withNullPropertiesAsUndefined(
    pick(updatableProperties, a),
  );

  const bUpdatableProperties = withNullPropertiesAsUndefined(
    pick(updatableProperties, b),
  );

  return (
    JSON.stringify(aUpdatableProperties) ===
    JSON.stringify(bUpdatableProperties)
  );
};

const updatableSiteAvailabilityContentProperties = [
  'isCancelled',
  'start',
  'end',
  'notes',
] as const;
/** /todo */

export const areEqualUpdatableContentProperties = <
  TUpdatableA extends Partial<
    Record<(typeof updatableSiteAvailabilityContentProperties)[number], any>
  >,
  TUpdatableB extends Partial<
    Record<(typeof updatableSiteAvailabilityContentProperties)[number], any>
  >,
>(
  a: TUpdatableA,
  b: TUpdatableB,
): boolean =>
  areUpdatablePropertiesEqualAcrossObjects(
    updatableSiteAvailabilityContentProperties as any,
    a,
    b,
  );
